


























import {
  Vue, Component, Prop, Model,
} from 'vue-property-decorator';
import TextInput from '../../components/ui/TextInput.vue';
import FlashError from '../../components/ui/FlashError.vue';
import ICurrentWord from '@/types/ICurrentWord';
import messageBus from '../../utils/MessageBus';

// noinspection JSUnusedGlobalSymbols
@Component({
  components: {
    TextInput,
    FlashError,
  },
})
export default class CurrentWord extends Vue {
  $refs!: {
    audioW: HTMLMediaElement,
    audioM: HTMLMediaElement,
  };

  @Prop() id!: string;
  @Prop() currentWord!: ICurrentWord;
  @Prop() error!: {
    code: string,
    message: string,
  };

  @Model('input', { type: String }) readonly submission!: string;

  get submissionVal(): string {
    return this.submission;
  }

  set submissionVal(v) {
    this.$emit('input', v);
  }

  // noinspection JSMethodCanBeStatic
  handlePlayingEnded(): void { // eslint-disable-line class-methods-use-this
    messageBus.$emit('enableInput', true);
    messageBus.$emit('audioPlaying', false);
  }

  playCurrentWord(): void {
    messageBus.$emit('audioPlaying', true);
    messageBus.$emit('enableInput', false);
    const audioElem: HTMLMediaElement = Math.random() < 0.5 ? this.$refs.audioM : this.$refs.audioW;
    audioElem.load();
    const playPromise: Promise<void> = audioElem.play();
    if (playPromise !== undefined) {
      playPromise.catch((error: Error) => {
        // make sure to re-enable input if play gets the dreaded DOMException error
        Vue.$log(`${audioElem.id} play error`, error);
        messageBus.$emit('enableInput', true);
      });
    }
  }

  // noinspection JSUnusedGlobalSymbols
  mounted(): void {
    // handler to play audio of current word
    messageBus.$on('playCurrentWord', this.playCurrentWord);
  }

  // noinspection JSMethodCanBeStatic
  beforeDestroy(): void { // eslint-disable-line class-methods-use-this
    messageBus.$off('playCurrentWord', this.playCurrentWord);
  }
}
